import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Table from "../ui/Table";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { InfoIcon, SortIcon } from "../utils/Icons";
import { bm_date, drawPOSStatus, drawPrice, istl, requestPrompt, showConfirm } from "../utils/Utils";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from "dayjs";
import Space from "../ui/Space";
import Card from "../ui/Card";
import Label from "../ui/Label";
import Divider from "../ui/Divider";
import Input from "../ui/Input";
import { useTabs } from "../hooks/useTabs";
import { KBD } from "../utils/Keybindings";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import { drawPicker } from "../popovers/Picker";
import { ENUMS } from "../utils/Enums";
import ISBNSearch from "./pos/ISBNSearch";
import { createModal } from "../hooks/createModal";
import Nav from "../ui/Nav";
import { apiCall } from "../utils/Api";
import { TRANSACTION_ITEM } from "../utils/Struct";
import { pos_addItem, pos_removeItem, pos_startNewTransaction, pos_editItem } from "../controllers/POSController";
import Cookies from "js-cookie";
import Status from "../ui/Status";
import PriceField from "../ui/PriceField";
import InventorySearch from "../popups/InventorySearch";
import { drawProductSearch } from "../controllers/GlobalConroller";
export default function POSItems(props) {

    const { toggleView = () => { }, setSelectedItem = () => { } } = props;

    const NEW_ROW = { pos_id: "", __new: true };

    const {
        employee = "",
        controller = "",
        signal = {},
        loading = false,
        showTender = () => { },
        setLoading = () => { },
        header = {},
        setHeader = () => { },
        route = "",
        align = "auto",
        setAlign = () => { },
        state = {},
        setState = () => { },
        cancelEdit = () => { },
    } = props;

    const row_key = "pos_id"
    const buffer = 20;
    const [data, setData] = useState([]);
    const skip_invoice_check = useRef(false);



    useEffect(() => {
        setData(props.items)
    }, [props.items])

    // data with new row added. 
    const tableData = state.edit
        ? [...data, NEW_ROW]
        : data;

    const isNewRow = (row) => row?.__new === true || row?.pos_id === "";

    const [selected, setSelected] = useState({})
    const lastCustPoRef = useRef(header?.purchase_order || "");


    const getStock = (_stock) => {
        if (_stock?.stc_id) {
            pubCall("stock.getSingleExtras", { stock_id: _stock.stc_id }, (_s, _r) => {
                if (_s) {
                    setSelectedItem({ stock_data: _r.stock, in_stock: true, switchEdit: props.closeEdit })
                }
            })
        } else {
            setSelectedItem({ stock_data: selected, in_stock: true, switchEdit: props.closeEdit })
        }
    }



    useEffect(() => {

        getStock(selected);

    }, [selected])

    const blurField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.blur === 'function') {
            el.blur();
        }
    }

    const focusField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
    }

    const fetchItems = () => {
        // pos_id - for remembering...
        if (state.view !== "items") return;


        if (!header?.invoice) {
            setData([])
            return;
        }

        setLoading(true);
        pubCall("point_of_sale.getInitialItem", { sort: "id", invoice: header?.invoice, limit: 40 }, (_s, _r) => {
            if (_s) {
                setData(_r.rows_next);
                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})

            }
            setLoading(false)
        })
    }

    useEffect(fetchItems, [state.view, header]);


    const showSearch = () => {
        drawProductSearch({
            controller: controller, return_search: true, callback: (_obj) => {
                if (_obj) {


                    setTimeout(() => {
                        if (_obj?.title_link) {
                            addItem({ primary_code: _obj.title_link.primary_code, condition_code: " "}, true)
                        } else {
                            addItem({ primary_code: _obj.primary_code, condition_code: _obj.condition_code }, true)
                        }

                        window.bm_state.value = route;
                    }, 100)

                    // setData(prev => [...prev, _r.item]);
                    // resetNewItemRow();

                    //window.bm_state.value = route;
                    //update("primary_code", _obj.primary_code);

                }
            }
        })
    }


    const searchISBN = (_search) => {
        window.bm_state.value = ROUTES.POS.SEARCH_ISBN;
        createModal({
            component: <ISBNSearch
                callback_on_single_result
                controller={controller}
                search={_search} route={ROUTES.POS.SEARCH_ISBN} />,
            closable: true,
            title: "Select Item (Multiple Matches)",
            callback: (e) => {
                if (e) {
                    addItem(e, true);
                }
                window.bm_state.value = ROUTES.POS.CUSTOMER;
            }
        })
    }

    const addItemToInventory = (_item) => {
        props.addTitle(_item, (_stock) => {
            if (_stock) {
                addItem({ primary_code: _stock.primary_code, condition_code: _stock.condition_code })
            } else {

            }
        })

    }

    const resetNewItemRow = () => {
        setTabs(makeDefaultTabs());
        setIndex("primary_code");

        setState(s => ({
            ...s,
            edit: true,
            adding: true,
            editing: null,
            show_pos_card: true,
        }));

        setSelected(NEW_ROW);
    };


    const addItem = (_title, _force = false) => {

        blurField();

        if (!_title?.primary_code) return;
        if (_title?.primary_code.length < 13 && !_force) {
            searchISBN(_title?.primary_code);
            return;
        }
        const custPo = getVal("cust_po") || "";
        lastCustPoRef.current = custPo;

        const item = {
            ...TRANSACTION_ITEM,
            cust_po: getVal("cust_po"),
            primary_code: _title?.primary_code,
            condition_code: _title?.condition_code || "",
            quantity: Number(getVal("quantity")) || 1,
            price: Number(getVal("price")) || 0,
            discount: Number(getVal("discount")) || 0,
        };

        if (!header?.invoice || skip_invoice_check?.current) {
            // does not exits, create

            pos_startNewTransaction({ header: header, item: item, check_onhands: !_force, employee: employee }, (_s, _r) => {

                if (_s) {
                    setHeader(_r.header);
                    Cookies.set("pos_id", _r?.posh_id);
                    props.fetch();
                    setData(prev => [...prev, _r.items_first[0]]);
                    props.addNewRow(_r.header)
                    resetNewItemRow();
                    skip_invoice_check.current = false;
                } else {

                    if (_r.error === "com.bmo.not_enough_onhands") {
                        showConfirm({
                            controller: controller,
                            route: route, title: "Warning", description: <div style={{ "textAlign": "center" }}>Qty sold is greater than the OnHand<br /><div className="shim" />Allow negative OH?<div className="shim" /><div className="shim" /></div>, callback: (_key) => {
                                if (_key) {
                                    addItem(_title, true)
                                } else {
                                    focusField();
                                }
                            }
                        })

                    }

                    else if (_r.error === "com.bmo.does_not_exist") {
                        // prompt to add to inventory... 
                        showConfirm({
                            controller: controller,
                            route: route, title: "Warning", description: <div style={{ "textAlign": "center" }}><strong>{item.primary_code}</strong> <br /> was not found. <br /><div className="shim" /> Add to inventory?</div>, callback: (_key) => {
                                if (_key) {
                                    addItemToInventory(item);
                                } else {
                                    focusField();
                                }
                            }
                        })
                    } else {
                        showError(_r);
                    }
                }


            });
        } else {
            // add
            pos_addItem({ invoice: header.invoice, item: item, check_onhands: !_force, employee: employee }, (_s, _r) => {

                if (_s) {
                    setData(prev => [...prev, _r.item]);
                    resetNewItemRow();

                } else {
                    if (_r.error === "com.bmo.not_enough_onhands") {
                        showConfirm({
                            controller: controller,
                            route: route, title: "Warning", description: <div style={{ "textAlign": "center" }}>Qty sold is greater than the OnHand<br /><div className="shim" />Allow negative OH?<div className="shim" /><div className="shim" /></div>, callback: (_key) => {
                                if (_key) {
                                    addItem(_title, true);
                                } else {
                                    focusField();
                                }
                            }
                        })

                    } else {
                        showError(_r)
                    }

                }


            });
        }
    };

    const removeItem = () => {

        showConfirm({
            controller: controller,
            route: route,
            description: <div style={{ "textAlign": "center" }}>Delete row?</div>,
            title: "Warning",
            callback: (e) => {
                if (e) {
                    pos_removeItem({ point_of_sale_id: selected?.[row_key], employee: employee }, (_s, _r) => {
                        if (_s) {



                            showMessage("Row removed.")
                            const updated = data.filter(item => item[row_key] !== selected?.[row_key]);
                            const deleted = data.findIndex(row => row[row_key] === selected?.[row_key]);
                            setData(updated);

                            if (!updated?.length) {
                                skip_invoice_check.current = true;
                                nextItem()
                            } else {
                                setSelected(updated[deleted - 1] || updated[0] || {});
                            }


                        } else {
                            showError(_r);
                        }
                    })
                }
            }
        })
    }

    const cancelRowEdit = () => {
        blurField(index);

        setTabs(makeDefaultTabs());
        setIndex("primary_code");

        setState(s => ({
            ...s,
            edit: true,
            adding: false,
            editing: null,
            show_pos_card: true,
        }));

        requestAnimationFrame(() => {
            // keep table row selected, but no field focused
            refs.current?.[index]?.blur?.();
        });
    };


    const editSelectedItemRow = () => {
        if (!selected?.[row_key]) return;

        setTabs([
            { label: "cust_po", key: "cust_po", value: selected?.cust_po || "" },
            { label: "primary_code", key: "primary_code", value: selected?.primary_code || "", skip: true },
            { label: "quantity", key: "quantity", value: selected?.quantity ?? 1 },
            { label: "price", key: "price", value: selected?.price ?? 0 },
            { label: "discount", key: "discount", value: selected?.discount ?? 0 },
            { label: "tax_code", key: "tax_code", value: selected?.tax_code || "" },
        ]);

        setState(s => ({
            ...s,
            edit: true,
            adding: false,
            editing: selected[row_key],
            show_pos_card: true,
        }));

        setIndex("cust_po");

        requestAnimationFrame(() => {
            refs.current?.cust_po?.focus?.();
            refs.current?.cust_po?.select?.();
        });
    };


    const saveEditedRow = () => {
        if (!state?.editing || !selected?.[row_key]) return;

        blurField(index);

        const item = {
            ...selected,

            cust_po: getCurrentVal("cust_po") || "",
            primary_code: selected.primary_code, // locked while editing
            quantity: Number(getCurrentVal("quantity")) || 0,
            price: Number(getCurrentVal("price")) || 0,
            discount: Number(getCurrentVal("discount")) || 0,
            tax_code: getCurrentVal("tax_code") || "",
        };

        pos_editItem({ item, employee }, (_s, _r) => {
            if (_s) {
                const updatedItem = _r?.item || item;

                setData(prev =>
                    prev.map(row =>
                        row[row_key] === selected[row_key]
                            ? { ...row, ...updatedItem }
                            : row
                    )
                );

                setSelected(prev => ({ ...prev, ...updatedItem }));

                setTabs(makeDefaultTabs());
                setIndex("primary_code");

                setState(s => ({
                    ...s,
                    edit: true,
                    adding: false,
                    editing: null,
                    show_pos_card: true,
                }));

                showMessage("Row saved.");
            } else {
                showError(_r);

                requestAnimationFrame(() => {
                    refs.current?.[index]?.focus?.();
                });
            }
        });

    };

    const getCurrentTabs = () => {
        const currentKey = index;
        const currentEl = refs.current?.[currentKey];

        return tabs.map(tab => {
            if (tab.key !== currentKey) return tab;

            const liveValue =
                currentEl && "value" in currentEl
                    ? currentEl.value
                    : tab.value;

            return {
                ...tab,
                value: liveValue,
            };
        });
    };

    const getCurrentVal = (_key) => {
        const currentTabs = getCurrentTabs();
        return currentTabs.find(tab => tab.key === _key)?.value;
    };

    const canEditRow = (row) => {
        if (window.bm_state.value !== ROUTES.POS.EDIT) return false;
        if (!state?.edit) return false;

        // adding new row
        if (state?.adding && isNewRow(row)) {
            return true;
        }

        // editing existing row
        if (!state?.adding && state?.editing && row?.[row_key] === state.editing) {
            return true;
        }

        return false;
    };



    const makeDefaultTabs = () => [
        { label: "cust_po", key: "cust_po", value: lastCustPoRef.current || header?.purchase_order || "" },
        { label: "primary_code", key: "primary_code", value: "" },
        { label: "quantity", key: "quantity", value: 1 },
        { label: "price", key: "price", value: 0 },
        { label: "discount", key: "discount", value: header?.customer_ship_to?.discount || 0 },
        { label: "tax_code", key: "tax_code", value: "", skip: true },
    ];

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(makeDefaultTabs(), "primary_code");

    useLayoutEffect(() => {
        if (!state.edit) return;
        requestAnimationFrame(() => {
            const el = refs?.current[index];
            if (el) el.focus();
        });

    }, [index, state.edit]);

    useLayoutEffect(() => {
        if (!state.edit || !state.adding) return;
        if (index !== "primary_code") return;

        requestAnimationFrame(() => {
            refs.current?.primary_code?.focus?.();
            refs.current?.primary_code?.select?.();
        });
    }, [state.edit, state.adding, index, selected]);

    useEffect(() => { })

    const switchToCustomer = () => {
        setState({ ...state, "view": "customer", show_pos_card: true, editing: null })
        window.bm_state.value = ROUTES.POS.CUSTOMER;
    }

    const switchToTransaction = () => {
        props.editTransaction();
    }

    const testIt = (item) => {
        requestPrompt({
            route: ROUTES.POS.POS, title: "Tobias Testing stuff..", inputProps: { style: { "textAlign": "left" } }, callback: (_s) => {
                let _itm = { ...item, "quantity": parseInt(_s) || 0 };
                pubCall("point_of_sale.editItem", { item: _itm }, (_s, _r) => {
                    if (_s) {
                        console.log(_r);
                    } else {
                        console.log(_r);
                        showError(_r);
                    }
                })
            }
        })
    }

    useEffect(() => {
        if (!state.edit) {
            if (skip_invoice_check?.current) {
                skip_invoice_check.current = false;
            }
            return;
        }

        const actions = (state.adding || state.editing) ? pos_new_nav : pos_edit_nav;

        const cleanup = listen(
            controller,
            ROUTES.POS.EDIT,
            actions,
            false,
            [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE, KBD.PAGE_DOWN]
        );

        return cleanup;
    }, [index, tabs, refs, state.adding, selected, data, state.edit, state.editing, state.show_pos_card]);





    const columns = [
        { min: true, width: 50, key: "available_onhand", align: "right", title: <>aOH</> },
        { min: true, width: 130, key: "class", align: "left", title: <>Class</> },
        { min: true, width: 100, grow: true, key: "title", align: "left", title: <>Title</> },
        {
            min: true, width: 123, key: "cust_po", align: "left", title: <>CustPo</>, render: (e, f) => {
                if (canEditRow(f)) {

                    return <><Input className="fill" {...editProps("cust_po")} onEnter={() => next()} edit={state.edit} width={110} /></>
                } else {
                    return e
                }
            }
        },
        {
            min: true, width: 163, key: "primary_code", align: "left", title: <>ISBN</>, render: (e, f) => {
                if (canEditRow(f) && !state.editing) {
                    return <>
                        <Input className="fill" {...editProps("primary_code")} onPageDown={(_value, f) => {
                            f.preventDefault();
                            f.stopPropagation();

                            if (state?.editing) {
                                saveEditedRow();
                                return;
                            }

                            if (_value === "") {
                                // empty proceed to tender
                                showTender(header)
                            } else {
                                addItem({ primary_code: _value, condition_code: "" })
                            }
                        }} onEnter={(_value) => { addItem({ primary_code: _value, condition_code: "" }) }} onPageUp={(e, f) => {
                            f.preventDefault();
                            f.stopPropagation();
                            showSearch()
                        }} edit={state.edit} width={150} />
                    </>
                } else {
                    return e
                }
            }
        },
        {
            min: true, width: 48, key: "quantity", align: "right", title: <>Qty</>, render: (e, f) => {
                if (canEditRow(f)) {
                    return <><Input className="fill" {...editProps("quantity")} number onEnter={() => next()} right maxLength={3} edit={state.edit} width={35} /></>
                } else {
                    return e
                }
            }
        },
        {
            min: true, width: 85, key: "price", align: "right", title: <>Price</>, render: (e, f) => {
                if (canEditRow(f)) {
                    return <><PriceField className="fill" {...editProps("price")} price onEnter={() => next()} right edit={state.edit} width={72} /></>
                } else {
                    return drawPrice(e, true)
                }
            }
        },
        {
            min: true, width: 35, key: "discount", align: "right", title: <>%</>, render: (e, f) => {

                let _class = ((f.discount_expected && f?.[row_key]) && (f.discount_expected !== Number(e)));

                if (canEditRow(f)) {
                    return <><Input className={(_class) ? "fill error" : "fill"} {...editProps("discount")} right number onEnter={() => next()} maxLength={2} edit={state.edit} width={22} /></>
                } else {
                    if (_class) {
                        return <><Input style={{ "fontWeight": "300" }} className={(_class) ? "fill error" : "fill"} value={e} right number maxLength={2} edit={false} width={22} /></>
                    } else {
                        return e;
                    }

                }
            }
        },
        {
            min: true, width: 50, key: "tax_code", align: "right", title: <>Tax</>, render: (e, f) => {
                if (canEditRow(f) && state.editing) {
                    return <><Input className={"fill"} {...editProps("tax_code")} right number onEnter={() => next()} maxLength={1} edit={state.edit} width={37} /></>
                } else {
                    return e
                }
            }
        },
        { min: true, width: 50, key: "points", align: "right", title: <>Pts</> },
        { min: true, width: 80, key: "total_price", align: "right", title: <>Total</> },
        { min: true, width: 90, key: "prepay_status", align: "left", title: <>PPY</> },
    ];

    const fetchNext = () => {
        if (loading || data.length < 40) { return }
        setLoading(true);
        pubCall("point_of_sale.getNextItem", { invoice: header?.invoice, "limit": 20, "pos_id": data[data.length - 1]?.[row_key], sort: "id" }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    const fetchPrev = () => {
        if (loading || data.length < 40) { return }
        setLoading(true);
        pubCall("point_of_sale.getPreviousItem", { invoice: header?.invoice, "limit": 20, "pos_id": data[0]?.[row_key], sort: "id" }, (_s, _r) => {
            if (_s) {
                setAlign("start")
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    const nextItem = (_rows = 1) => {

        if (
            state.edit &&
            _rows === 1 &&
            selected?.[row_key] === data[data.length - 1]?.[row_key]
        ) {
            showNewRow();
            return;
        }
        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");
        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };

    const prevItem = (_rows = 1) => {
        if (_rows === 1 && state.edit && selected?.[row_key] === data[0]?.[row_key]) {
            switchToCustomer();
            return;
        }

        if (data.length === 0) { setSelected({}); return; }

        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;
        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }

        if (prevIndex < 1) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };


    const statuses = {
        cust_po: "Customer's PO# or a notation",
        primary_code: "Enter or scan ISBN, ↑ ↓ to move, <PdDn> to tender, <PgUp> to look up",
        quantity: "Enter a quantity from -999 to 999, <F5> will repeat +/- (sell/return) mode",
        price: "Entering a price before the ISBN overides the ISBN's price",
        discount: "Enter discount. <F5> for options to change all discounts",
        tax_code: "Tax codes: 1 = Tax1, 2 = Tax2, B = Tax1&2, <F5> to repeat/change all "
    }


    const pos_new_nav = [
        {
            key: KBD.ESCAPE, action: () => {

               
                
                if (!selected?.invoice) {
              
                    cancelNewRow();
                    return;
                }

                if (state?.editing != null) {
                    cancelRowEdit();
                    return;
                }

                

                cancelEdit(refs?.current?.[index], ROUTES.POS.EDIT);

            }
        },
        {
            key: KBD.PAGE_DOWN, action: () => {

                if (state?.editing !== null) {
                    saveEditedRow();
                } else {
                    showTender(header)
                }
            }
        },
        { key: KBD.ARROW_DOWN, action: () => { next() } },
        {
            key: KBD.ARROW_UP, action: () => {

                if (index === "cust_po") {
                    if (data.length === 0 || (selected?.[row_key] === data[data.length - 1]?.[row_key] && data.length > 1)) {
                        switchToCustomer()
                    } else {
                        setState(s => ({ ...s, edit: true, adding: false, editing: null }));
                        if (state.editing) {

                        } else {
                            setSelected(data[data.length - 1])
                        }

                    }

                } else {
                    prev()
                }
            }
        },
    ];

    const cancelNewRow = () => {
        blurField(index);
        setTabs(makeDefaultTabs());
        setIndex("primary_code");
    

        setState(s => ({
            ...s,
            edit: !!header?.invoice || data.length > 0,
            adding: false,
            editing: null,
            show_pos_card: true,
        }));

        if (!header?.invoice && data.length === 0) {
            skip_invoice_check.current = false;
        }

        cancelEdit(refs?.current?.[index], ROUTES.POS.EDIT);
    };

    const showNewRow = () => {

        setTabs(makeDefaultTabs());
        setIndex("primary_code");

        setState(s => ({
            ...s,
            edit: true,
            adding: true,
            editing: null,
            show_pos_card: true,
        }));

        setSelected(NEW_ROW);
    };


    const pos_items_nav = [
        { key: KBD.ESCAPE, action: () => toggleView() },
        { key: KBD.ARROW_DOWN, action: () => nextItem() },
        { key: KBD.ARROW_UP, action: () => prevItem() },
        { key: KBD.PAGE_DOWN, action: () => showTender(header) },
        { key: KBD.V, text: "View", action: () => toggleView() },
        { key: KBD.N, text: "New", action: showNewRow },
        { key: KBD.E, text: "Edt", action: () => { switchToTransaction() } },
        { key: KBD.ALT_E, text: "@Edt", action: () => props.editTitle() },
    ];


    useEffect(() => {
        if (state.edit) { return; }

        const cleanup = listen(
            controller,
            ROUTES.POS.ITEMS,
            pos_items_nav,
            false,
            [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE, KBD.PAGE_DOWN]
        );

        return cleanup;
    }, [selected, data, state.edit]);


    const pos_edit_nav = [
        { key: KBD.ESCAPE, action: () => { cancelEdit(refs?.current?.[index], ROUTES.POS.EDIT); } },
        { key: KBD.PAGE_DOWN, action: () => showTender(header) },
        { text: "Cpy" },
        { key: KBD.V, text: "View", action: () => { setState(s => ({ ...s, show_pos_card: !state.show_pos_card })); } },
        { key: KBD.N, text: "New", action: showNewRow },
        { key: KBD.D, text: "Del", action: removeItem },
        { key: KBD.E, text: "Edt", action: () => editSelectedItemRow() },

        { key: KBD.ALT_E, text: "@Edt", action: () => props.editTitle() },

        { text: "GftRct" },
    ]





    return (
        <div>
            <div onClick={() => {
                if (state?.edit && window.bm_state.value === ROUTES.POS.CUSTOMER) {
                    switchToTransaction();
                }
            }} style={{ "padding": "0px 15px" }}>





                <Label style={{ "textAlign": "left" }}>&nbsp;Transaction Items:</Label>
                <div className="shim" />
                <Space size={10} style={{ alignItems: "start" }}>

                    {/* TABLE */}
                    {/* {!(state.edit || state.adding) && ( */}
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 600 }}>
                        <VirtualTable
                            className={(state.view !== "items") ? "desaturate" : ""}
                            row_height={26}
                            controller={controller}
                            onRowDoubleClick={(e) => {
                            
                                if(e?.__new){
                                    update("primary_code", "9780993888090")
                                }
                                
                            }}
                            onRowClick={(item) => {
                                if (state.editing) {
                                    return;
                                }
                                setAlign("auto");
                                setSelected(item);
                            }}
                            next={nextItem}
                            prev={prevItem}
                            align={align}
                            row_key={"pos_id"}
                            current={(state.adding) ? {} : (state.edit) ? selected : {}}
                            data={tableData}
                            height={200}
                            columns={columns}
                            width={0}
                            loading={loading}
                            offset={430}
                            route={route}
                            scrollbar={true}
                            scrollindicator={true}
                            infinite={true}
                        />
                    </div>
                    {/* )} */}

                    {/* POS CARD */}
                    <Card
                        header={<Label style={{ textAlign: "left" }}>POS Transaction Log</Label>}
                        style={{ width: "282px" }}
                        secondary
                    >
                        <Label>POS Transaction Log</Label>
                    </Card>

                </Space>



            </div>

            {(state.view === "items" && (state.adding || state.edit)) && <>
                <div className="shim" />
                <Divider />

                {((state.adding || state.editing) && <div style={{ "padding": "0px 15px", "marginTop": "8px" }}>
                    <Status><InfoIcon />{statuses?.[index] ?? ""}</Status>
                </div>)}
                {(state.edit &&
                    <div style={{ 'height': "30px" }}>
                        <Space style={{ "padding": "0px 15px" }}>
                            <Nav nav={(state.adding) ? pos_new_nav : pos_edit_nav} />
                        </Space>
                    </div>
                )}

            </>}

        </div>
    )
}